import * as React from 'react'
import { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import '../../../App.css'
import '../../../css/modal.scss'
import { updateModal } from '../../../store/common/common_action'
import { getBranchReceiveLastReceivePrint, getUpdateReceive, getUpdateReceiveV2, getUpdateShortReceive } from '../../../store/branchTransferReceive/branchReceive_action'
import LineInput from '../../common/lineinput'
import { Item } from '../../common/snippets'
import Modal from '../../common/modal'
import LoaderScreen from '../../common/loader'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import ReceivedItem from './ReceivedItem'
import { focusElemnt, navigation3 } from '../../common/helper'
import { useAtom } from 'jotai'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { branchTransferFilteredTableRowsAtom } from '../../common/jotaiState/dispatchStateAtoms'
import { GUJRAT_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { makeTable } from '../Reports/analysisReport/pdfAutotable'
import { divideInNIntegers } from '../../common/mathHelper'
import { withPxWidths } from '../../common/mathHelper'
import { lrDetailPdfFooter } from '../AcountingReport/common/AcountingConstants'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import { useTranslation } from '../../../i18n/I18nProvider'
import { getValidationMessages } from '../../../i18n/validationMessages'
const BottomSection = ({
  getUpdateReceive,
  getUpdateShortReceive,
  getBranchReceiveLastReceivePrint,
  updateModal,
  data,
  topSelectedData,
  tSecDropData,
  selectedData,
  setTSecDropData,
  indexSetState,
  setTopSelectedData,
  setSelectedData,
  setShowBtnList,
  setSelectedChallanData,
  setSelectedVehicleData,
  handleAlert,
  inputCheck,
  getUpdateReceiveV2,
  chaVehWise

}) => {
  const { translations } = useTranslation()
  const btr = translations?.branchTransferReceive || {}
  const cs = translations?.common || {}
  const error = getValidationMessages(translations)
  const { common, BranchTransferReceiveReducer, delivery } = data
  const { brnchList, cityList, strtCity, loginData, strtBrnch, showModal, modalType, alert, loader, roleRights } = { ...common }
  const { listData } = { ...BranchTransferReceiveReducer }
  const [companySettings] = useAtom(companySettingsAtom)
  const [filteredTableRows] = useAtom(branchTransferFilteredTableRowsAtom)
  const { BTRChallanPortrait } = companySettings

  const { receive, shortReceive, branchreceiveLastReceivePrint } = { ...BranchTransferReceiveReducer }
  const [successModal, setSuccessModal] = useState({
    Receive: { id: 'Receive', lrListLabel: 'Receive popup modal', isSaved: false },
    ShortReceive: { id: 'ShortReceive', lrListLabel: 'Short Receive popup modal', isSaved: false },
    ReceiveSuccess: { id: 'ReceiveSuccess', lrListLabel: 'Receive Success popup modal', isSaved: false },
    ShortReceiveSuccess: { id: 'ShortReceiveSuccess', lrListLabel: 'Short Success Receive popup modal', isSaved: false },
    LastReceivePrint: { id: 'LastReceivePrint', lrListLabel: 'Last Receive Print popup modal', isSaved: false },
    ReceivedItemList: { id: 'ReceivedItemList', lrListLabel: 'Received Item List popup modal', isSaved: false },
  })

  const [selectedPrintData, setSelectedPrintData] = useState(null)
  const [filteredPreviewPdfUrl, setFilteredPreviewPdfUrl] = useState('')
  const [state, setState] = useState({
    Remarks: '',
    LrNo: [],
    BookingID: [],
    shortQtys: [],
    damageQtys: [],
    BranchTransferID: [],
    BranchTransferDetID: [],
    load: false,
    generatePDF: false,
    filteredPreviewGeneratePDF: false,
    received: false,
    lastReceivePrint: false,
    dFromBranchForPrint: '',
  })
  const {
    Remarks,
    LrNo,
    BookingID,
    shortQtys,
    damageQtys,
    BranchTransferID,
    BranchTransferDetID,
    load,
    generatePDF,
    filteredPreviewGeneratePDF,
    received,
    dFromBranchForPrint,
    lastReceivePrint,
  } = state


  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }

  // All UseEffect

  useEffect(() => {
    if (selectedData?.length >= 1) {
      const lr = selectedData?.map((item) => item.LRNO)
      const bookingid = selectedData?.map((item) => item.BookingID)
      const branchTransferId = selectedData?.map((item) => item.BranchTransferID)
      const branchTransferDetId = selectedData?.map((item) => item.BranchTransferDetID)

      const ShortQtys = selectedData.map((item) => 0)
      const DamageQtys = selectedData.map((item) => 0)

      setState({
        ...state,
        LrNo: lr,
        BookingID: bookingid,
        shortQtys: ShortQtys,
        damageQtys: DamageQtys,
        BranchTransferID: branchTransferId,
        BranchTransferDetID: branchTransferDetId,
      })
    } else {
      setState({ ...state, LrNo: [], BookingID: [], shortQtys: [], damageQtys: [] })
    }
  }, [selectedData])

  useEffect(() => {
    if (receive.status == true || receive.status === 'Success') {
      getBranchReceiveLastReceivePrint(selectedData)
      updateModal(true, 'ReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', SellectedChallanNumber: "" })
      setState({ ...state, Remarks: '' })
      indexSetState({ showListTable: false, showListAllTable: false })
      setTopSelectedData({
        ...topSelectedData,
        DFromBranch: null,
        SelectedVehicle: "",
        resetData: true,
      })
      setSelectedData([])
      setSelectedChallanData([])
      setSelectedVehicleData([])
      setShowBtnList(true)
    } else {
      handleAlert(receive?.ErrMessage || receive?.Message)
    }
  }, [receive])
  useEffect(() => {
    if (shortReceive.status == true) {
      updateModal(true, 'ShortReceiveSuccess')
      setTSecDropData({ ...tSecDropData, selectconsignmentType: 'All', SellectedChallanNumber: 'All' })
      setState({ ...state, Remarks: '' })
      indexSetState({ showListTable: false, showListAllTable: false })
      setTopSelectedData({
        ...topSelectedData,
        DFromBranch: null,
        SelectedVehicle: "",
        resetData: true,
      })
      setShowBtnList(true)
      setSelectedChallanData([])
      setSelectedVehicleData([])
      setSelectedData([])
    } else {
      handleAlert(shortReceive?.ErrMessage)
    }
  }, [shortReceive])

  useEffect(() => {
    if (showModal && modalType === 'FilteredTablePreview' && filteredPreviewGeneratePDF) {
      generateFilteredTablePreviewPdf()
    }
  }, [showModal, modalType, filteredPreviewGeneratePDF])
  //All useEffect End
  const formatPreviewDate = (value) => {
    if (!value) return ''
    const parsed = moment(value)
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : value
  }

  const getFilteredTablePreviewRows = () => {
    let totalUnits = 0
    let totalAmount = 0

    const rows = (filteredTableRows || []).map((item, index) => {
      const quantity = Number(item?.Quantity || 0)
      const amount = Number(item?.NetAmount || 0)
      totalUnits += quantity
      totalAmount += amount

      return {
        srNo: index + 1,
        LRNO: item?.LRNO || '',
        ManualLRNo: item?.ManualLRNo || '',
        BookingDate: formatPreviewDate(item?.BookingDate),
        DescriptionDet: item?.ConsignmentData?.length === 1 ? item?.DescriptionDet || '' : 'Multi',
        PaymentType: item?.PaymentType || '',
        Quantity: quantity,
        Sender: item?.Sender || '',
        RecName: item?.RecName || '',
        FromCity: item?.FromCity || '',
        ToCity: item?.ToCity || '',
        NetAmount: amount,
      }
    })

    rows.push({
      srNo: 'Total',
      Quantity: totalUnits,
      NetAmount: totalAmount,
      dataType: 'total',
      colSpan: { srNo: 6 },
      align: { srNo: 'left' }
    })

    return rows
  }

  const generateFilteredTablePreviewPdf = (isSave = false) => {
    if (!filteredTableRows?.length) {
      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
      updateModal(false)
      handleAlert(btr.noFilteredBranchTransferRowsFound)
      return
    }

    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = [
      { header: 'SN', dataKey: 'srNo', xlCol: { dataType: 'string' }, weight: 20 },
      { header: 'LR No.', dataKey: 'LRNO', xlCol: { dataType: 'string' }, weight: 50 },
      { header: 'Manual LR', dataKey: 'ManualLRNo', xlCol: { dataType: 'string' }, weight: 50 },
      { header: 'Booking Date', dataKey: 'BookingDate', xlCol: { dataType: 'string' }, weight: 50 },
      { header: 'Consign Type', dataKey: 'DescriptionDet', xlCol: { dataType: 'string' }, weight: 60 },
      { header: 'Payment Type', dataKey: 'PaymentType', xlCol: { dataType: 'string' }, weight: 40 },
      { header: 'Units', dataKey: 'Quantity', xlCol: { dataType: 'number' }, weight: 40 },
      { header: 'Sender', dataKey: 'Sender', xlCol: { dataType: 'string' }, weight: 60 },
      { header: 'Receiver', dataKey: 'RecName', xlCol: { dataType: 'string' }, weight: 100 },
      { header: 'From City', dataKey: 'FromCity', xlCol: { dataType: 'string' }, weight: 50 },
      { header: 'To City', dataKey: 'ToCity', xlCol: { dataType: 'string' }, weight: 40 },
      { header: 'Amount', dataKey: 'NetAmount', xlCol: { dataType: 'number' }, weight: 50 },
    ]

    const previewRows = getFilteredTablePreviewRows()
    const bodyData = previewRows.map((row) => ({
      ...row,
      dataType: row.srNo === 'Total' ? 'total' : 'entry',
    }))

    const orientation = pdfColumns.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const totalPagesExp = '{total_pages_count_string}'

    const doc = new jsPDF({ orientation, format, unit: 'px', compress: true })
    doc.setProperties({
      title: 'Branch Transfer Filter Preview.pdf',
      subject: 'Branch Transfer Filter Preview',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Branch Transfer Receive',
      creator: 'MTLPL',
    })

    const pdfCols = withPxWidths(pdfColumns, format[0] - 60).map(col => ({
      header: col.header,
      dataKey: col.dataKey,
      xlCol: col.xlCol,
      width: col.width || 0,
    }))

    const customFunction = (data) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text('Cargo System | Transfer Filter Preview', 90, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name: ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }

    makeTable(doc, autoTable, pdfCols, bodyData,  1.214, 'Transfer Filter Preview', loginData, 'everyPage', customFunction, 120, false, true, true, { isLargeRowHeight: true })

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    const pdfUrl = doc.output('bloburl')
    setFilteredPreviewPdfUrl(pdfUrl)

    if (isSave) {
      doc.save(`Branch Transfer Filter Preview ${moment(new Date()).format('DD-MMM-YYYY HH-mm')}.pdf`)
    }

    setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: false }))
  }

  const printClick = () => {
    if (branchreceiveLastReceivePrint === undefined || !branchreceiveLastReceivePrint.length) {
      updateModal(false, 'LastReceivePrint')
      handleAlert(btr.noReceiveFound)
      return
    }

    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const columnDefs = [
      { header: 'Sr. No.', dataKey: 'srNo', xlCol: { dataType: 'string' }, weight: 40 },
      { header: 'LR No.', dataKey: 'LRNO', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Transfer Date', dataKey: 'BookingDate', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Received Date', dataKey: 'ReceivedDate', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Transfer By Branch', dataKey: 'TransferByBranch', xlCol: { dataType: 'string' }, weight: 120 },
      { header: 'Received By Branch', dataKey: 'ReceivedByBranch', xlCol: { dataType: 'string' }, weight: 120 },
      { header: 'Sender Name', dataKey: 'Sender', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Receiver Name', dataKey: 'RecName', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Vehicle No', dataKey: 'VehicleNo', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Challan No.', dataKey: 'VoucherNo', xlCol: { dataType: 'string' }, weight: 70 },
      { header: 'Payment Type', dataKey: 'PaymentType', xlCol: { dataType: 'string' }, weight: 70 },
      { header: 'Consignment Type', dataKey: 'DescriptionDet', xlCol: { dataType: 'string' }, weight: 80 },
      { header: 'Units', dataKey: 'Quantity', xlCol: { dataType: 'number' }, weight: 50 },
      { header: 'Gross Amount', dataKey: 'NetAmount', xlCol: { dataType: 'number' }, weight: 70 },
    ]

    let UnitsTotal = 0
    let GrossAmt = 0

    const bodyData = []

    if (!lastReceivePrint) {
      branchreceiveLastReceivePrint?.forEach((item, i) => {
        UnitsTotal += item.Quantity
        GrossAmt += item.NetAmount
        bodyData.push({
          ...item,
          dataType: 'entry',
          srNo: i + 1,
          TransferByBranch: dFromBranchForPrint,
          ReceivedByBranch: strtBrnch.BranchName,
          ReceivedDate: moment(new Date()).format('DD-MMM-YYYY'),
        })
      })

      const lengths = divideInNIntegers(columnDefs.length, 3)
      let idx = 0
      const pickedKeys = []
      lengths.forEach((span) => { pickedKeys.push(columnDefs[idx]?.dataKey); idx += span })

      bodyData.unshift({
        dataType: 'subHeader',
        totalSubKey: 3,
        colSpan: Object.fromEntries(pickedKeys.map((key, i) => [key, lengths[i]])),
        align: { [pickedKeys[0]]: 'left', [pickedKeys[1]]: 'center', [pickedKeys[2]]: 'right' },
        [pickedKeys[0]]: `Transfer Type: ${branchreceiveLastReceivePrint?.[0]?.TransferType}`,
        [pickedKeys[1]]: `Destination City: ${branchreceiveLastReceivePrint?.[0]?.ToCity}`,
        [pickedKeys[2]]: `Destination Branch: ${branchreceiveLastReceivePrint?.[0]?.DestinationBranchName}`,
      })

      bodyData.push({
        dataType: 'total',
        srNo: 'Total',
        Quantity: UnitsTotal,
        NetAmount: GrossAmt,
        colSpan: { srNo: columnDefs.length - 2 },
        align: { srNo: 'right' },
      })
    } else {
      branchreceiveLastReceivePrint.forEach((item, i) => {
        bodyData.push({
          ...item,
          dataType: 'entry',
          srNo: i + 1,
        })
      })
    }

    const orientation = BTRChallanPortrait ? 'p' : 'l'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const totalPagesExp = '{total_pages_count_string}'

    const doc = new jsPDF({ orientation, format, unit: 'px', compress: true })
    doc.setProperties({
      title: 'Receive.pdf',
      subject: 'Receive Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    const pdfCols = withPxWidths(columnDefs, format[0] - 60).map(col => ({
      header: col.header,
      dataKey: col.dataKey,
      xlCol: col.xlCol,
      width: col.width || 0,
    }))

    const customFunction = (data) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text('Cargo System | Transfer Receive Report', 90, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name: ${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }

    makeTable(doc, autoTable, pdfCols, bodyData, 1, 'Transfer Receive Report', loginData, 'everyPage', customFunction, 120, false, true, true, { isLargeRowHeight: true })

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }

    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      document.getElementById('output').data = doc.output('datauristring', 'Receive.pdf')
    }, 2000)
  }

  const onKeyDown = (id, e) => {
    switch (id) {
      case 'branchReceivebtn':
        if (e.key === 'Enter') {
        } else if (e.key === 'Escape') {
          focusElemnt('remarksBranchReceive')
        }
        break
      case 'remarks':
        if (e.key === 'Enter') {
          focusElemnt('branchReceivebtn')
        } else if (e.key === 'Escape') {
          focusElemnt('showListBranchReceive')
        }
        break
      default:
        break
    }
  }
  const onClick = (id) => {
    switch (id) {
      case 'Receivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'Receive')
        }
        break
      case 'confirmReceive':
        if (inputCheck) {
          let bkgID = selectedData.map(({ BookingID }) => BookingID)
          const body = {
            FromBranchID: topSelectedData.DFromBranch.BranchID,
            CurrentBranchID: strtBrnch.BranchID,
            FromCityID: strtCity.CityID,
            CurrentCityID: strtCity.CityID,
            CompanyID: loginData.intCompanyID,
            VoucherNo: tSecDropData.SellectedChallanNumber === ""
              ? 0
              : tSecDropData?.SellectedChallanNumber?.VoucherNo,
            IsInMovement: 1,
            Mode: 1,
            Date: moment(new Date()).format('YYYY-MM-DD'),
            VehicleNo: chaVehWise === 1 ? '' : topSelectedData.SelectedVehicle.VehicleNo || "",
            VehicleID: chaVehWise === 1 ? 0 : topSelectedData.SelectedVehicle.VehicleID || 0,
            UserID: loginData.intUserID,
            Remarks: Remarks,
            IsBranchReceiveAllLrs: listData?.Table?.length === selectedData?.length ? 1 : 0,
            ExceptionDispatchIDs: listData?.Table?.filter((item) => !bkgID?.includes(item.BookingID))
              ?.map((obj) => obj?.BranchTransferID)
              ?.join('^'),
            ExceptionDispatchDetIDs: listData?.Table?.filter((item) => !bkgID?.includes(item.BookingID))
              ?.map((obj) => obj?.BranchTransferDetID)
              ?.join('^')
          }

          getUpdateReceiveV2(body)
        } else {
          const LRno = LrNo.join('^').toString()
          const branchId = BranchTransferID.join('^').toString()
          const branchDetId = BranchTransferDetID.join('^').toString()
          const bookingid = BookingID.join('^').toString()
          const shortQtyss = shortQtys.join('^').toString()
          const DamageQtys = damageQtys.join('^').toString()
          const receiveObj = {
            intSendingCityID: strtCity.CityID,
            intReceivedCityID: strtCity.CityID,
            intSendingBranchID: topSelectedData.DFromBranch.BranchID,
            intReceivedBranchID: strtBrnch.BranchID,
            strVehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
            strRemarks: Remarks,
            intVehicleID: topSelectedData.SelectedVehicle.VehicleID,
            strBranchTransferIDs: branchId,
            strBranchTransferDetIDs: branchDetId,
            strLRNos: LRno,
            strShortQtys: shortQtyss,
            strDamageQtys: DamageQtys,
            strBookingIDs: bookingid,
          }
          getUpdateReceive(loginData, receiveObj)
          // setSelectedPrintData(null)
          // setSelectedPrintData(selectedData)
        }
        setState({
          ...state,
          dFromBranchForPrint: topSelectedData?.DFromBranch?.BranchName,
          lastReceivePrint: false,
          load: false,
          generatePDF: false,
        })
        updateModal(false, 'Receive')

        break
      case 'CLosePopupReceive':
        updateModal(false, 'Receive')
        break
      case 'ShortReceivebtn':
        if (selectedData.length < 1) {
          handleAlert(error.SELECT_LR)
        } else {
          updateModal(true, 'ShortReceive')
        }
        break
      case 'confirmShortReceive':
        const shortbranchId = BranchTransferID.join('^').toString()
        const shortbookingid = BookingID.join('^').toString()
        const shortreceiveObj = {
          strBookingIDs: shortbookingid,
          strBranchTransferIDS: shortbranchId,
        }
        getUpdateShortReceive(loginData, shortreceiveObj)
        updateModal(false, 'ShortReceive')
        break
      case 'CLosePopupShortReceive':
        updateModal(false, 'ShortReceive')
        break
      case 'successfullReceive':
        updateModal(false, 'ReceiveSuccess')
        break
      case 'successfullReceiveclose':
        updateModal(false, 'ReceiveSuccess')
        break
      case 'successfullShortReceive':
        updateModal(false, 'ShortReceiveSuccess')
        break
      case 'SuccessFullReceive':
        setState({ ...state, received: true })
        printClick()
        break
      default:
        break
    }
  }
  const handleKeyDownConfirm = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    } else if (e.keyCode == 39) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    }
  }
  const handleKeyDownSuccess = (e, id) => {
    if (e.keyCode === 37) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    } else if (e.keyCode == 39) {
      if (id == "deliveryno") {
        focusElemnt("deliveryyes")
      } else if (id == "deliveryyes") {
        focusElemnt("deliveryno")
      }
    }
  }
  // All popup
  const ReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.confirm} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
               { btr.pleaseConfirmTransferConsignmentsFromTo 
                .replace('{fromBranch}', topSelectedData?.DFromBranch?.BranchName || '')
                .replace('{toBranch}', strtBrnch?.BranchName || '')}
              {/* Please confirm you want to Branch Receive consignment/s from {topSelectedData?.DFromBranch?.BranchName} to{' '}
              {strtBrnch?.BranchName} */}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              className="select-lr-btn"
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('confirmReceive')}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'deliveryyes')}
            >
              {cs.yes}
            </button>
            <Button
              id="deliveryno"
              className="select-lr-btn"
              variant="outlined"
              autoFocus
              color="error"
              onClick={() => onClick('CLosePopupReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
              onKeyDown={(e) => handleKeyDownConfirm(e, 'deliveryno')}
            >
             {cs.no}
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const ReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.success} width={load ? '90%' : '25%'} updateModal={updateModal}>
        <>
          {load ? (
            ''
          ) : (
            <>
              <Stack>
                <Box style={{ margin: '20px', fontSize: '16px' }}>
                  <div>{btr.successfulReceive}</div>
                  <div>{btr.doYouWantPrint}</div>
                </Box>
              </Stack>
              <Stack>
                <div className="modal-btn-grp">
                  <button
                    className="select-lr-btn"
                    id="deliveryyes"
                    style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                    onClick={() => printClick()}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'deliveryyes')}
                  >
                    {cs.yes}
                  </button>
                  <Button
                    className="select-lr-btn"
                    variant="outlined"
                    id="deliveryno"
                    color="error"
                    onClick={() => updateModal(false, 'ReceiveSuccess')}
                    style={{ cursor: 'pointer', fontSize: '12px' }}
                    onKeyDown={(e) => handleKeyDownSuccess(e, 'deliveryno')}
                    autoFocus
                  >
                    {cs.no}
                  </Button>
                </div>
              </Stack>
            </>
          )}
          {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
          {load ? (
            <object
              id="output"
              type="application/pdf"
              width="1330"
              height="600"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      </Modal>
    )
  }

  const ShortReceiveModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.confirm} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '20px', fontSize: '16px' }}>
            <div>
              {btr.pleaseConfirmShortTransferConsignmentsFromTo
                .replace('{fromBranch}', topSelectedData?.DFromBranch?.BranchName || '')
                .replace('{toBranch}', strtBrnch?.BranchName || '')}
              {/* Please confirm you want to Short Branch Receive consignment/s from {topSelectedData.DFromBranch.BranchName} to{' '}
              {strtBrnch.BranchName} */}
            </div>
          </Box>
        </Stack>
        <Stack>
          {/* background: '#f15a22' */}
          <div className="modal-btn-grp">
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', color: 'white', padding: '7px 20px', cursor: 'pointer', fontSize: '12px' }}
              onClick={() => onClick('confirmShortReceive')}
            >
              {cs.yes}
            </button>
            <Button
              className="select-lr-btn"
              variant="outlined"
              color="error"
              onClick={() => onClick('CLosePopupShortReceive')}
              style={{ cursor: 'pointer', fontSize: '12px' }}
            >
              {cs.no}
            </Button>
          </div>
        </Stack>
      </Modal>
    )
  }
  const ShortReceiveSuccessModal = (isRecve = false) => {
    return (
      <Modal headTxt={cs.success} width={'25%'} updateModal={updateModal}>
        <Stack>
          <Box style={{ margin: '10px', fontSize: '16px' }}>
            <div>{btr.successfulShortReceive}</div>
          </Box>
        </Stack>
        <Stack>
          <div className="modal-btn-grp" style={{ marginRight: '10px' }}>
            <button
              autoFocus
              id="deliveryyes"
              style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
              onClick={() => onClick('successfullShortReceive')}
            >
              {cs.ok}
            </button>
          </div>
        </Stack>
      </Modal>
    )
  }

  const LastReceivePrint = (isRecve = false) => {
    return (
      <Modal headTxt={btr.lastReceivePrint} width={load ? '90%' : '25%'} updateModal={updateModal}>
        {load ? (
          ''
        ) : (
          <>
            <Stack>
              <Box style={{ margin: '20px', fontSize: '16px' }}>
                <div>{btr.doYouWantLastReceivePrint}</div>
              </Box>
            </Stack>
            <Stack>
              <div className="modal-btn-grp">
                <button
                  autoFocus
                  id="deliveryyes"
                  style={{ background: '#fe5200', cursor: 'pointer', color: 'white', padding: '7px 20px', fontSize: '12px' }}
                  onClick={() => onClick('SuccessFullReceive')}
                >
                  {cs.yes}
                </button>

                <Button
                  className="select-lr-btn"
                  variant="outlined"
                  color="error"
                  onClick={() => updateModal(false, 'LastReceivePrint')}
                  style={{ cursor: 'pointer', fontSize: '12px' }}
                >
                 {cs.no}
                </Button>
              </div>
            </Stack>
          </>
        )}
        {generatePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
        {load ? (
          <object
            id="output"
            type="application/pdf"
            width="1330"
            height="600"
            title="MTLPL -Cargo System - After Transfer Summary Report"
            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
          ></object>
        ) : (
          ''
        )}
      </Modal>
    )
  }

  const ReceivedItemList = (isRecve = false) => {
    return (
      <Modal headTxt={btr.transferReceivedItemList} width={'95%'} updateModal={updateModal}>
        <Stack>
          <ReceivedItem handleAlert={handleAlert} />
        </Stack>
      </Modal>
    )
  }
  const FilteredTablePreviewModal = () => {
    return (
      <Modal headTxt={btr.transferFilterPreview} headText2={`${filteredTableRows.length} ${btr.rows}`} width={'95%'} updateModal={updateModal}>
        <>
          {filteredPreviewGeneratePDF ? <div className={'generatePDF'}>{cs.pdfGenerationMsg}</div> : ''}
          <Stack direction="row" spacing={2} style={{ padding: '12px 16px 0 16px', justifyContent: 'flex-end' }}>
            <Button
              variant="outlined"
              style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '13px', fontWeight: 'bold', marginBottom:'10px' }}
              onClick={() => generateFilteredTablePreviewPdf(true)}
              disabled={!filteredTableRows?.length || filteredPreviewGeneratePDF}
            >
              {btr.downloadPdf}
            </Button>
          </Stack>
          {filteredPreviewPdfUrl ? (
            <object
              id="branchTransferFilteredPreviewOutput"
              type="application/pdf"
              width="100%"
              height="650"
              data={filteredPreviewPdfUrl}
              title="MTLPL - Cargo System - Branch Transfer Filter Preview"
              aria-label="MTLPL - Cargo System - Branch Transfer Filter Preview"
            ></object>
          ) : (
            <div style={{ padding: '24px', minHeight: '200px' }}>
              {filteredPreviewGeneratePDF ? '' : btr.preparingPreview}
            </div>
          )}
        </>
      </Modal>
    )
  }


  return (
    <>
      {/* {loader ? <LoaderScreen /> : ''} */}
      <div className="bottom-section" style={{ width: '100%' }}>
        <Stack
          direction="row"
          divider={
            <Divider
              orientation="vertical"
              sx={{
                width: '2px',
                margin: '0px -16px 0px 0px !important',
                //   backgroundColor: "#0086ff",
                backgroundColor: '#DDD',
              }}
              flexItem
            />
          }
          spacing={2}
          sx={{ background: '#f0fcf4', width: '100%' }}
        >
          <Item sx={{ width: '30%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'inline-flex',
                padding: '0% 10px',
                background: '#f0fcf4',
              }}
            >
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <div className={'input--wrapper'}>
                  <LineInput
                    id="remarksBranchReceive"
                    type="text"
                    name={'SenGstnNo'}
                    label={cs.remarks}
                    value={Remarks}
                    // onKeyDown={(e) => onKeyDown('remarks', e)}
                    onKeyDown={(e) => navigation3(e, 'branchReceivebtn', 'checkbox_0')}
                    onChange={(e) => setState({ ...state, Remarks: e.target.value })}
                  // disabled={true}
                  />
                </div>
              </Item>
            </Box>
          </Item>
          <Item sx={{ width: '70%', paddingTop: '16px', background: '#f0fcf4' }}>
            <Box
              sx={{
                flexGrow: 1,
                width: '100%',
                display: 'flex',
                padding: '0% 10px',
                // marginTop: "15px",
                background: '#f0fcf4',
              }}
            >
              {loginData.intCompanyID === GUJRAT_COMPANY_ID && (
                <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                  <Button
                    variant="outlined"
                    sx={{ width: '100%' }}
                    style={{
                      borderColor: filteredTableRows?.length ? '#fe5200' : '#cccccc',
                      color: filteredTableRows?.length ? '#fe5200' : '#000',
                      fontSize: '15px',
                      fontWeight: 'bold',
                      textTransform: 'Uppercase',
                    }}
                    onClick={() => {
                      if (!filteredTableRows?.length) {
                        handleAlert(btr.noFilteredRows)
                        return
                      }
                      setFilteredPreviewPdfUrl('')
                      setState((prev) => ({ ...prev, filteredPreviewGeneratePDF: true }))
                      updateModal(true, 'FilteredTablePreview')
                    }}
                    disabled={!filteredTableRows?.length}
                  >
                    {cs.print}
                  </Button>
                </Item>
              )}
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => updateModal(true, "ReceivedItemList")}
                >
                  {btr.receivedItemLists}
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => {
                    setState({ ...state, load: false, generatePDF: false, lastReceivePrint: true })
                    updateModal(true, 'LastReceivePrint')
                  }}
                >
                  {btr.lastReceivePrint}
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  style={{ borderColor: '#fe5200', color: '#fe5200', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                  onClick={() => onClick('ShortReceivebtn')}
                  disabled={roleRights?.Table1?.[0]?.AllowShortReceipt == 0}
                >
                  {' '}
                  {btr.shortReceive}
                </Button>
              </Item>
              <Item sx={{ width: '100%', background: '#f0fcf4' }}>
                <Button
                  variant="contained"
                  id="branchReceivebtn"
                  sx={{ width: '100%' }}
                  style={{ backgroundColor: '#fe5200', fontSize: '15px', textTransform: 'Uppercase', color: '#fff', fontWeight: 'bold' }}
                  // onKeyDown={(e) => onKeyDown('branchReceivebtn', e)}
                  onKeyDown={(e) => navigation3(e, 'dispatchBranchReceive', "remarksBranchReceive", () => { })}
                  onClick={() => onClick('Receivebtn')}
                >
                  {' '}
                  {cs.receive}
                </Button>
              </Item>
            </Box>
          </Item>
        </Stack>
      </div>
      {showModal && [successModal.Receive.id].includes(modalType) && ReceiveModal(successModal.Receive.id)}
      {showModal && [successModal.ShortReceive.id].includes(modalType) && ShortReceiveModal(successModal.ShortReceive.id)}
      {showModal && [successModal.ReceiveSuccess.id].includes(modalType) && ReceiveSuccessModal(successModal.ReceiveSuccess.id)}
      {showModal && [successModal.LastReceivePrint.id].includes(modalType) && LastReceivePrint(successModal.LastReceivePrint.id)}
      {showModal && [successModal.ReceivedItemList.id].includes(modalType) && ReceivedItemList(successModal.ReceivedItemList.id)}
      {showModal && 'FilteredTablePreview'===modalType && FilteredTablePreviewModal()}
      {showModal &&
        [successModal.ShortReceiveSuccess.id].includes(modalType) &&
        ShortReceiveSuccessModal(successModal.ShortReceiveSuccess.id)}

    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateModal,
  getUpdateReceive,
  getUpdateShortReceive,
  getBranchReceiveLastReceivePrint,
  getUpdateReceiveV2,

}

export default connect(mapStateToProps, mapDispatchToProps)(BottomSection)
